import type { PolicySkillSummary } from "../types/ead-types.ts";

const CACHE_KEY = "ead-expui.policy-skills-summary.v1";

export function loadCachedPolicySkillSummaries(): PolicySkillSummary[] | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { skills?: PolicySkillSummary[] };
    return Array.isArray(parsed?.skills) ? parsed.skills : null;
  } catch {
    return null;
  }
}

export function saveCachedPolicySkillSummaries(skills: PolicySkillSummary[]): void {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ skills, savedAt: Date.now() }));
  } catch {
    /* ignore quota */
  }
}
